module.exports = __webpack_public_path__ + "img/apollon-logo-icon.c96bf157.png";